<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
export default {
    data() {
        return {
            tableData: [],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            sortField: '',
            sortRule: '',
            filterDrawer: false,
            filter: {
                open_id: '',
                username: '',
                mobile: '',
                task_type: '',
                timeVal: [],
            },
            tabData: [],
        };
    },
    methods: {
        init() {
            this.getPrizeList();
            this.getData();
        },
        async getData() {
            let data = await this.api.pointsystemTaskType({
                access_token: localStorage.getItem("access_token"),
            });
            this.tabData = data.data;
        },
        time(date) {
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            var h = date.getHours()
            h = h < 10 ? '0' + h : h
            var minute = date.getMinutes()
            minute = minute < 10 ? '0' + minute : minute
            var second = date.getSeconds()
            second = second < 10 ? '0' + second : second
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
        },
        async getPrizeList() { 
            let { open_id, username, mobile, task_type } = this.filter
            let params = {
                access_token: localStorage.getItem("access_token"),
                page: this.currentPage,
                limit: this.pageSize,
                open_id,
                username,
                mobile,
                task_type,
            }
            if(this.filter.timeVal.length > 0){
                let d = new Date(this.filter.timeVal[0]);
                let finish_time_start = this.time(d);
                let e = new Date(this.filter.timeVal[1]);
                let finish_time_end = this.time(e);
                params.created_at_start = finish_time_start;
                params.created_at_end = finish_time_end;
            }
            if(this.$route.query.taskType){
                params.task_type = this.$route.query.taskType;
                this.filter.task_type = this.$route.query.taskType;
            }

            //完成任务记录api

            let data = await this.api.pointsystemCompletionList(params)
            if(data) {
                this.tableData = data.data
                this.total = data.total
            }
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.getPrizeList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.getPrizeList()
            this.tableScrollTop()
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        async searchClick() {
            this.currentPage = 1

            await this.getPrizeList()
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = { open_id: '', username: '', mobile: '', task_type: '', timeVal: [] }
        }
    },
    created() {
        this.init()
    },
};
</script>
